import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBackButton,
  FDBodyText,
  FDDialogActions, FDDialogContent, FDPrimaryActionButton,
} from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { refreshModalCollection, clearModalCollection } = useModalContext();

  return (
    <>
      <MetaControlField attr="title" />
      <FDDialogContent>
        <MetaControlField attr="description" />
        <FDBodyText value={resource.attr('description')} />
        <MetaLayoutVertical resource={resource} />
      </FDDialogContent>
      <FDDialogActions>
        <FDBackButton onClick={clearModalCollection} />
        <FDPrimaryActionButton
          onClick={refreshModalCollection}
          {...dataAttrs('continue-btn', resource)}
          label="Continue →"
        />
      </FDDialogActions>
    </>
  );
};

export default Layout;
